export const translations = {
  en: {
    // Navigation
    nav: {
      home: "Home",
      theDay: "The Day",
      gettingThere: "Getting There",
      accommodation: "Accommodation",
      lakeComo: "Lake Como",
      rsvp: "RSVP",
    },
    // Home Page
    home: {
      wereGettingMarried: "We're Getting Married!",
      lakeComo: "Lake Como, Italy",
      saveTheDate: "Save the Date",
      date: "17th October 2026",
      sposiamo: "Celebrate With Us",
      welcomeText:
        "We are so excited to celebrate our special day with you at beautiful Lake Como in Italy! Please explore our website to learn more about the wedding details, accommodation, and things to do.",
      ourCeremony: "Our Marriage Ceremony",
      ceremonyText:
        "Join us for our symbolic ceremony in Como. We would be delighted to share this moment with you!",
      joinUs: "Join Us in Italy",
      joinUsText:
        "We will have a private event in the heart of Como, where we'll eat, drink, and dance the day away. So many of us are spread throughout the world and we don't see each other often anymore — it will be fantastic to have a day with you all.",
      eveningTitle: "An Evening to Remember",
      eveningText:
        "As the sun sets over Lake Como, join us for an enchanting evening of celebration under the stars. The timeless beauty of Villa Revel Parravicini combined with the stunning panoramic view of the lake at night will create a magical atmosphere for dining, dancing, and making memories that will last a lifetime.",
      exploreLakeComo: "Explore Lake Como",
      exploreIntro: "Stay for a few days and enjoy Cinzia's homeland!",
      breathtakingViews: "Breathtaking Views",
      breathtakingViewsText:
        "Discover stunning panoramic views of the lake and surrounding mountains.",
      italianCharm: "Italian Charm",
      italianCharmText:
        "Experience authentic Italian culture in charming cafes and piazzas.",
      historicVillages: "Historic Villages",
      historicVillagesText:
        "Wander through picturesque villages along the lakeside.",
    },
    // The Day Page
    theDay: {
      title: "The Day",
      subtitle: "17th October 2026",
      introText:
        "Join us for a day of celebration, love, and unforgettable memories at our beautiful Lake Como wedding. Here's what to expect on our special day.",
      venue: "The Venue",
      venueDescription:
        "Our wedding will take place at Villa Revel Parravicini, a historic 18th-century villa nestled in the heart of Como city, overlooking Lake Como. This elegant neoclassical villa features beautiful gardens, breathtaking lake views, and timeless Italian architecture — the perfect romantic setting for our special day.",
      venueTitle: "Villa Revel Parravicini",
      venueAddress: "Via Museo Giovio, 6, 22100 Como CO, Italy",
      scheduleTitle: "Schedule of Events",
      scheduleSubtitle: "A day filled with love, laughter, and celebration",
      welcome: "Welcome",
      welcomeTime: "15:30",
      welcomeText:
        "Welcome to Villa Revel Parravicini! Join us for a welcome drink as you arrive and take in the surroundings.",
      ceremony: "Ceremony",
      ceremonyTime: "16:15",
      ceremonyText:
        "Join us for our symbolic ceremony at the villa, overlooking Lake Como.",
      aperitif: "Aperitif",
      aperitifTime: "16:45",
      aperitifText:
        "Enjoy aperitivo with drinks and canapés on the Italian-style garden.",
      dinner: "Dinner",
      dinnerTime: "19:00",
      dinnerText:
        "A delicious Italian feast awaits! Enjoy a multi-course dinner featuring local specialties and fine wines.",
      cake: "Cutting of the Cake",
      cakeTime: "21:00",
      cakeText:
        "Join us for the traditional cutting of the wedding cake and a sweet toast to celebrate.",
      party: "Party & Open Bar",
      partyTime: "21:30",
      partyText:
        "Let's dance the night away! Join us on the dance floor for an evening of music, celebration, and unforgettable moments with an open bar.",
      midnight: "Saluto di Mezzanotte",
      midnightTime: "24:00",
      midnightText: "Midnight farewell - everyone goes home like Cinderella!",
      dressCode: "Dress Code",
      dressCodeText: "Formal attire, please.",
      photography: "Photography",
      photographyText:
        "We have a professional photographer capturing our special day. Feel free to take photos, but we kindly ask for an unplugged ceremony.",
      gifts: "Gifts",
      giftsText:
        "Your presence is the greatest gift. If you would also like to give us a wedding gift, we kindly ask for a cash contribution towards renovating our home. Thank you for helping us build our future together!",
      weather: "Weather",
      weatherText:
        "October in Lake Como is typically mild and pleasant. We recommend bringing a light jacket or wrap for the evening.",
      menu: "Menu",
      menuText:
        "Expect a full traditional Italian food and wine and a full-course dinner! Please let us know of any dietary requirements in advance!",
    },
    // Accommodation Page
    accommodation: {
      title: "Accommodation",
      subtitle: "Where to Stay in Lake Como",
      introText1:
        "Lake Como offers a wonderful selection of accommodations, from luxurious lakeside hotels to charming vacation apartments. Our wedding planner curated options to help you find the perfect place to stay during our celebration.",
      introText2:
        "We recommend spending the night of the wedding in Como city, because public transport typically stops at midnight. The villa is easily reachable on foot from almost any part of the city.",
      bookingTip:
        "When booking, we recommend mentioning that you are attending Cinzia and Joseph's wedding.",
      hotelsTitle: "Recommended Hotels",
      hotelsSubtitle: "Elegant accommodations with stunning lake views",
      apartmentsTitle: "Recommended Apartments",
      apartmentsSubtitle: "Spacious apartments perfect for families or groups",
      visitWebsite: "Visit Website →",
      otherSourcesTitle: "Other Sources",
      otherSourcesText:
        "For more accommodation options, check out Booking.com, Airbnb, or contact local travel agencies in Como.",
    },
    // Getting There Page
    gettingThere: {
      title: "Getting There",
      subtitle: "Travel Information for Lake Como",
      introText1:
        "Lake Como is easily accessible from Milan and other major European cities. Here's everything you need to know about travelling to our wedding.",
      introText2:
        "Cars can be rented at airports. If you rent a car when booking your airline ticket, it is much cheaper.",
      byAir: "By Air",
      byTrain: "By Train",
      malpensaTitle: "Milan Malpensa Airport (MXP)",
      malpensaText:
        "The closest major international airport, approximately 1 hour by car from Lake Como. Direct flights available from most major cities worldwide.",
      linateTitle: "Milan Linate Airport (LIN)",
      linateText:
        "Closer to Milan city center, about 1 hour by car from Lake Como. Good option for European flights.",
      bergamoTitle: "Milan Bergamo Airport (BGY)",
      bergamoText:
        "Popular with budget airlines, approximately 1 hour by car from Lake Como. Often has competitive fares from European cities.",
      fromMalpensaTitle: "From Milan Malpensa Airport",
      fromMalpensaText:
        "Take the train from Malpensa to Milano Centrale, then connect to Como. Total journey approximately 1 hour. Alternatively, take the train to Mendrisio in Switzerland and transfer to Como Lago.",
      fromLinateTitle: "From Milan Linate Airport",
      fromLinateText:
        "Take the metro from Linate to San Babila (blue line), change to the red line to reach Milano Cadorna station (approximately 15 minutes). From Cadorna, take the train to Como Lago (approximately 1 hour).",
      fromBergamoTitle: "From Milan Bergamo Airport",
      fromBergamoText:
        "Take the airport bus to Milano Centrale station (approximately 1 hour). From Milano Centrale, take the train to Como (approximately 1 hour).",
      directToComoTitle: "Direct to Como",
      directToComoText:
        "Como has two main train stations: Como San Giovanni (for trains from Milano Centrale) and Como Lago (for trains from Milano Cadorna). Como Lago is closer to the lakefront.",
      lastTrainsTitle: "Last Trains to Como",
      lastTrainsText:
        "Please note the last train times when planning your arrival: the last train from Milano Centrale to Como San Giovanni departs around 22:43, and the last train from Milano Cadorna to Como Lago departs around 23:16. We recommend booking flights that land at least 3 hours before the last train to allow time for baggage collection, customs (if applicable), travel to the train station, and possible flight delays.",
      arrivingAtVenueTitle: "Arriving at the Venue",
      arrivingAtVenueText:
        "Villa Revel Parravicini is easily accessible on foot from anywhere in Como city center, from the pier, and from both train and bus stations. We strongly recommend staying in Como city center the night of the wedding, as bus, boat, and train services will have ended by the time the wedding finishes at midnight.",
    },
    // Location Page
    location: {
      title: "Lake Como",
      subtitle: "Explore the Area",
      introText:
        "Lake Como is one of Italy's most enchanting destinations, nestled in the foothills of the Alps. Known for its dramatic scenery, elegant and aristocratic villas, and charming lakeside towns, it has been a retreat for artists, writers, and celebrities for centuries. Whether you're exploring the cobblestone streets of Como city, taking a boat to picturesque villages, or simply enjoying an aperitivo by the water, Lake Como offers unforgettable experiences at every turn.",
      exploringComoTitle: "Exploring Como City",
      comoPara1:
        "Como is a pretty little city nestled amongst the foothills of the Alps, with the stunning backdrop of Lake Como creating a picturesque setting. The historic center is a delightful maze of narrow cobblestone streets, lined with elegant clothes shops, inviting cafes, lively bars, and authentic restaurants.",
      comoPara2:
        "Take a leisurely walk along the lakefront promenade, where you can enjoy spectacular views all the way to the charming village of Cernobbio — an easy and scenic stroll. Visit the magnificent Duomo di Como, the city's historic cathedral that beautifully blends Gothic and Renaissance architecture.",
      comoPara3:
        "For breathtaking panoramic views, take the funicular railway up to Brunate, a hillside village offering stunning vistas of the lake and surrounding mountains. Art and history enthusiasts can explore Como's beautiful villas, such as the neoclassical Villa Olmo with its lakeside gardens and rotating art exhibitions.",
      restaurantsTitle: "Recommended Restaurants & Bars",
      restaurants: [
        {
          name: "Bar Krudo",
          type: "Italian Bar & Cafe",
          description:
            "Located on the beautiful Piazza Alessandro Volta, this Italian bar and cafe is perfect for drinks and casual dining with a view of the lake.",
        },
        {
          name: "Il Pinzimonio",
          type: "Ristorante, Pizzeria, Cotoletteria",
          description:
            "Located in the very heart of Como city centre, Il Pinzimonio is a landmark for many locals. Its constantly updated menu offers a wide range of traditional Italian dishes, with chicken and veal cutlets and Neapolitan-style pizza among its specialties.",
          website: "https://il-pinzimonio.com/",
        },
        {
          name: "Osteria del Gallo",
          type: "Traditional Osteria",
          description:
            "One of Como's last true osterias, run for 41 years by Giuseppe De Toma and family. Authentic old-world atmosphere with daily changing menu based on seasonal ingredients. Specialties include fresh ravioli, pizzoccheri, braised meats with polenta, lake fish, and homemade desserts. Extensive wine selection.",
        },
        {
          name: "Pronobis",
          type: "Wine Shop & Eatery",
          description:
            "A wine shop and eatery specializing in wines from small Italian producers, featuring natural, organic, and biodynamic options. Kitchen open daily for lunch and Saturday evenings with seasonal menu. Also offers artisanal cheeses, cured meats, and local products.",
        },
        {
          name: "Ristorante Osteria dal Pain",
          type: "Traditional Local Cuisine",
          description:
            "A true institution in Como's local restaurant tradition with Lake Como as its backdrop. Offers authentic regional fare combining local ingredients with traditional Italian culinary excellence.",
        },
        {
          name: "Caffè Maya",
          type: "Café & Coffee Roastery",
          description:
            "Artisan coffee roastery with multiple locations in Como. Perfect for a quick drink at the bar or to enjoy their famous Italian hot chocolate. Known for quality coffee and cozy atmosphere.",
        },
      ],
      recommendedPlatesTitle: "Recommended Plates",
      platesPara1:
        "Como's cuisine reflects its location in the foothills of the Alps, blending mountain and alpine traditions with northern Italian flavors.",
      platesPara2:
        "The region is known for hearty, rustic dishes that showcase local ingredients like polenta, lake fish, and rich meats. Here are some must-try traditional dishes during your visit:",
      plates: [
        {
          name: "Pizzoccheri",
          description:
            "A hearty buckwheat pasta dish from the nearby Valtellina valley, layered with potatoes, cabbage, garlic, and generous amounts of local cheese (usually Casera and Bitto), finished with butter and sage. Perfect for cooler mountain evenings.",
        },
        {
          name: "Ossobuco",
          description:
            "Braised veal shanks cooked slowly in white wine, broth, and vegetables until the meat is fall-off-the-bone tender. Traditionally served with risotto alla milanese or polenta, and topped with gremolata (lemon zest, garlic, and parsley).",
        },
        {
          name: "Risotto alla Milanese",
          description:
            "The iconic golden risotto from nearby Milan, colored and flavored with saffron. Creamy and luxurious, made with butter, Parmigiano-Reggiano, and bone marrow. Often served alongside ossobuco but delicious on its own.",
        },
        {
          name: "Cotoletta alla Milanese",
          description:
            "A breaded veal cutlet, pounded thin and fried in butter until golden and crispy. Similar to Wiener schnitzel but with its own Milanese character. Simple, classic, and utterly satisfying.",
        },
        {
          name: "Polenta",
          description:
            "A cornerstone of northern Italian mountain cuisine, this cornmeal porridge is served soft and creamy or cooled and grilled. Often accompanied by braised meats, mushrooms, or local cheeses. Look for polenta taragna, made with buckwheat flour for extra flavor.",
        },
        {
          name: "Tagliatelle con Porcini",
          description:
            "Fresh ribbon pasta tossed with porcini mushrooms, a prized ingredient from the alpine forests. The earthy, aromatic mushrooms are typically sautéed with garlic, parsley, and a touch of cream or butter. A celebration of the region's foraging traditions and autumn harvest.",
        },
      ],
      exploringLakeTitle: "Exploring Lake Como",
      lakePara1:
        "Lake Como is dotted with picturesque villages, all easily accessible by boat from the ferry terminal in Como city. Each village offers its own unique charm and character, making boat hopping a delightful way to explore the region.",
      lakePara2:
        'Bellagio, the main tourist attraction, is known as the "Pearl of Lake Como" and sits at the point where the lake splits into two branches. This beautiful village enchants visitors with its winding cobblestone streets, colorful buildings, elegant gardens, and stunning lakeside views.',
      lakePara3:
        "Closer to Como, you'll find charming Torno, a very pretty village perfect for a peaceful visit, and Cernobbio with its lovely lakefront promenade. Further up the lake, Bellano features a dramatic large waterfall, while Varenna captivates with its beautiful waterfront lined with pastel-colored houses.",
      lakePara4:
        "For a unique cultural experience, visit the historic Abbazia Cistercense di Santa Maria di Piona, a Cistercian monastery high up the lake dating back to 1138. This peaceful sanctuary offers a glimpse into centuries of monastic life and stunning views of the surrounding landscape.",
      localTransportTitle: "Local Transportation",
      transportIntro:
        "Once at Lake Como, boats, buses and taxis are the primary means of transportation between towns. The villa is easily accessible by foot from anywhere in Como city and from the pier, if you stay in another village and take a boat.",
      boatsTitle: "Boats",
      boatsPara1:
        "Boats are cheap and affordable. Every town has a pier and boats are relatively frequent. There is a fast boat (hydrofoil) that is convenient if journeying higher up the lake (beyond Bellagio), but it sells out fast and you cannot book boat tickets online.",
      boatsPara2:
        "If you plan to travel higher up the lake, you should get up early on the day and go to the pier to book the fast boat.",
      boatsPara3: "The boat service typically ends at 22:00.",
      busesTitle: "Buses",
      busesPara1:
        "Buses are also a cheap and convenient way to travel around the lake. They are not as frequent as boats but they are a good option if you want to avoid the crowds at the pier.",
      busesPara2:
        "You can pay for your ticket directly on the bus using a debit or credit card.",
      busesPara3: "The bus service typically ends at 00:00.",
      taxisTitle: "Taxis",
      taxisPara1:
        "Taxis are readily available but very expensive. A fifteen minute journey can cost €60.",
      taxisPara2:
        "Uber and other taxi-like services are not readily available or reliable in Como.",
    },
    // RSVP Page
    rsvp: {
      title: "RSVP",
      subtitle: "Join Us for Our Special Day",
      intro:
        "We would be honored to have you celebrate with us! Please let us know if you'll be able to attend.",
      yourName: "Your Name",
      yourNameTooltip: "Please enter your full name",
      yourNamePlaceholder: "e.g., John Smith",
      willYouAttend: "Will you be attending?",
      pleaseEnterNameFirst: "Please enter your name first",
      yesAttending: "Yes, I'll be there! 🎉",
      noAttending: "Sorry, I can't make it",
      otherGuestsAttending: "Other Guests in Your RSVP Attending",
      otherGuestsAttendingTooltip:
        "Please enter the full name of each guest in your party",
      guestFullName: "Guest",
      fullName: "Full Name",
      addGuestAttending: "+ Add Guest Attending",
      otherGuestsNotAttending: "Other Guests in Your RSVP Not Attending",
      otherGuestsNotAttendingTooltip:
        "If you know of guests who cannot attend, please list their names here",
      addGuestNotAttending: "+ Add Guest Not Attending",
      attendingBabies: "Attending Babies (Under 18 Months)",
      attendingBabiesTooltip: "Select which guests are babies under 18 months",
      selectBaby: "Select Baby",
      addBaby: "+ Add Baby",
      attendingChildren: "Attending Children (Under 10 Years)",
      attendingChildrenTooltip:
        "Select which guests are children between 18 months and 10 years",
      selectChild: "Select Child",
      addChild: "+ Add Child",
      dietaryRequirements: "Dietary Requirements",
      dietaryRequirementsTooltip:
        "Select dietary requirements for your guests (Vegan, Vegetarian)",
      none: "None",
      vegan: "Vegan",
      vegetarian: "Vegetarian",
      selectGuest: "Select Guest",
      addDietaryRequirement: "+ Add Dietary Requirement",
      foodAllergies: "Food Allergies",
      foodAllergiesTooltip:
        "List any food allergies for your guests to ensure everyone's safety",
      foodAllergiesPlaceholder: "e.g., Peanuts, Shellfish, Dairy",
      addFoodAllergy: "+ Add Food Allergy",
      messageToCouple: "Message to the Couple",
      messageToCoupleTooltip:
        "Share your excitement, well wishes, or any questions!",
      messagePlaceholder: "We can't wait to celebrate with you! 💕",
      submitRSVP: "Submit RSVP",
      validationError: "Please fill in all required fields correctly.",
      successMessage: "Thank you for your RSVP! We'll see you there! 💒",
      successMessageAttending: "We look forward to seeing you there! 🎉",
      successMessageNotAttending:
        "We're sorry not to see you and will catch up soon! 💕",
      // Personalized card messages
      dearGuest: "Dear",
      thankYouAttending:
        "Thank you so much for confirming your attendance at our wedding. We are absolutely delighted that you will be joining us on our special day.",
      thankYouNotAttending:
        "Thank you for letting us know. While we are sad that you won't be able to join us on our special day, we completely understand and hope to celebrate with you soon.",
      thankYouMixed:
        "Thank you for your response. We're delighted that some of your party will be joining us, and we understand that not everyone can make it. We look forward to celebrating with those who can attend.",
      lookForwardTo: "We look forward to celebrating with you at Lake Como.",
      withLove: "With love and excitement,",
      coupleNames: "Cinzia & Joseph",
      errorMessage:
        "There was an error submitting your RSVP. Please try again.",
      joeAlertTitle: "Not So Fast, Joe Schuldt!",
      joeAlertMessage: "You are only allowed to attend this wedding.",
      joeAlertInsult: "Gobshite.",
      joeAlertButton: "OK, Send Acceptance! 🎉",
    },
    // Footer
    footer: {
      location: "Lake Como, Italy",
      year: "2026",
      message: "With love and anticipation",
    },
  },
  it: {
    // Navigation
    nav: {
      home: "Home",
      theDay: "Il Grande Giorno",
      gettingThere: "Come Arrivare",
      accommodation: "Alloggio",
      lakeComo: "Lago di Como",
      rsvp: "RSVP",
    },
    // Home Page
    home: {
      wereGettingMarried: "Ci Sposiamo!",
      lakeComo: "Lago di Como, Italia",
      saveTheDate: "Segnate la data",
      date: "17 ottobre 2026",
      sposiamo: "Festeggiate con Noi!",
      welcomeText:
        "Siamo così entusiasti di celebrare il nostro giorno speciale con voi sul bellissimo Lago di Como in Italia! Esplorate il nostro sito web per saperne di più sui dettagli del matrimonio, l'alloggio e le cose da fare.",
      ourCeremony: "La Nostra Cerimonia",
      ceremonyText:
        "Unitevi a noi per la nostra cerimonia simbolica a Como. Saremmo felici di condividere questo momento con voi!",
      joinUs: "Unitevi a noi in Italia",
      joinUsText:
        "Festeggeremo con un evento privato nel cuore di Como, dove mangeremo, berremo e balleremo tutto il giorno. Molti di noi sono sparsi in tutto il mondo e non ci vediamo più così spesso — sarà fantastico passare una giornata con tutti voi.",
      eveningTitle: "Una Serata Indimenticabile",
      eveningText:
        "Al calar del sole sul Lago di Como, unitevi a noi per una serata incantevole di festa sotto le stelle. La bellezza senza tempo di Villa Revel Parravicini, unita alla splendida vista panoramica del lago di notte, creerà un'atmosfera magica per cenare, danzare e vivere momenti che dureranno per tutta la vita.",
      exploreLakeComo: "Esplorate il Lago di Como",
      exploreIntro:
        "Restate qualche giorno e godetevi la terra natale di Cinzia!",
      breathtakingViews: "Viste Mozzafiato",
      breathtakingViewsText:
        "Scoprite viste panoramiche mozzafiato del lago e delle montagne circostanti.",
      italianCharm: "Fascino Italiano",
      italianCharmText:
        "Vivete l'autentica cultura italiana in affascinanti caffè e piazze.",
      historicVillages: "Borghi Storici",
      historicVillagesText:
        "Passeggiate attraverso pittoreschi borghi lungo il lago.",
    },
    // The Day Page
    theDay: {
      title: "Il Grande Giorno",
      subtitle: "17 ottobre 2026",
      introText:
        "Unisciti a noi per una giornata di celebrazione, amore e ricordi indimenticabili durante il nostro meraviglioso matrimonio sul Lago di Como. Ecco cosa ti aspetta nel nostro giorno speciale.",
      venue: "La Location",
      venueDescription:
        "Il nostro matrimonio si svolgerà presso Villa Revel Parravicini, una villa storica del XVIII secolo situata nel cuore della città di Como, con vista sul Lago di Como. Questa elegante villa neoclassica presenta bellissimi giardini, viste mozzafiato sul lago e un'architettura italiana senza tempo — l'ambientazione romantica perfetta per il nostro giorno speciale.",
      venueTitle: "Villa Revel Parravicini",
      venueAddress: "Via Museo Giovio, 6, 22100 Como CO, Italia",
      scheduleTitle: "Programma della giornata",
      scheduleSubtitle: "Una giornata piena di amore, risate e festa",
      welcome: "Benvenuto",
      welcomeTime: "15:30",
      welcomeText:
        "Benvenuti a Villa Revel Parravicini! Unitevi a noi per un drink di benvenuto mentre arrivate e ammirate i dintorni.",
      ceremony: "Cerimonia",
      ceremonyTime: "16:15",
      ceremonyText:
        "Unitevi a noi per la nostra cerimonia simbolica alla villa, con vista sul Lago di Como.",
      aperitif: "Aperitivo",
      aperitifTime: "16:45",
      aperitifText:
        "Godetevi l'aperitivo con drink e stuzzichini sulla terrazza.",
      dinner: "Cena",
      dinnerTime: "19:00",
      dinnerText:
        "Vi aspetta un delizioso banchetto italiano! Godetevi una cena di più portate con specialità locali e vini pregiati.",
      cake: "Taglio della Torta",
      cakeTime: "21:00",
      cakeText:
        "Unitevi a noi per il tradizionale taglio della torta nuziale e un dolce brindisi per festeggiare.",
      party: "Festa e Open Bar",
      partyTime: "21:30",
      partyText:
        "Balliamo! Unitevi a noi sulla pista da ballo per una serata di musica, festa e momenti indimenticabili con open bar.",
      midnight: "Saluto di Mezzanotte",
      midnightTime: "24:00",
      midnightText: "Saluto di mezzanotte  tutti a casa come Cenerentola!",
      dressCode: "Codice di Abbigliamento",
      dressCodeText: "Abbigliamento formale, per favore.",
      photography: "Fotografia",
      photographyText:
        "Avremo un fotografo professionista che catturerà il nostro giorno speciale. Sentitevi liberi di scattare foto, ma Vi invitiamo gentilmente a vivere la cerimonia senza dispositivi elettronici.",
      gifts: "Regali",
      giftsText:
        "La vostra presenza è il regalo più grande. Se desiderate farci anche un regalo di nozze, vi chiediamo gentilmente un contributo in denaro per la ristrutturazione della nostra casa. Grazie per aiutarci a costruire insieme il nostro futuro!",
      weather: "Meteo",
      weatherText:
        "Ottobre sul Lago di Como è tipicamente mite e piacevole. Vi consigliamo di portare una giacca leggera o uno scialle per la sera.",
      menu: "Menu",
      menuText:
        "Aspettatevi piatti e vini tradizionali italiani e una cena completa! Vi preghiamo di comunicarci eventuali esigenze dietetiche in anticipo!",
    },
    // Accommodation Page
    accommodation: {
      title: "Alloggio",
      subtitle: "Dove Alloggiare sul Lago di Como",
      introText1:
        "Il Lago di Como offre una meravigliosa selezione di alloggi, da lussuosi hotel sul lago ad affascinanti appartamenti per vacanze. Il nostro wedding planner ha selezionato alcune opzioni per aiutarvi a trovare il posto perfetto in cui soggiornare durante la nostra celebrazione.",
      introText2:
        "Vi consigliamo di trascorrere la notte del matrimonio nella città di Como, perché i trasporti pubblici di solito si fermano a mezzanotte. La villa è facilmente raggiungibile a piedi da quasi ogni parte della città.",
      bookingTip:
        "Al momento della prenotazione, vi consigliamo di indicare che parteciperete al matrimonio di Cinzia e Joseph.",
      hotelsTitle: "Hotel Consigliati",
      hotelsSubtitle: "Alloggi eleganti con splendide viste sul lago",
      apartmentsTitle: "Appartamenti Consigliati",
      apartmentsSubtitle:
        "Appartamenti spaziosi perfetti per famiglie o gruppi",
      visitWebsite: "Visita il Sito →",
      otherSourcesTitle: "Altre Fonti",
      otherSourcesText:
        "Per ulteriori opzioni di alloggio, consultate Booking.com, Airbnb o contattate le agenzie di viaggio locali a Como.",
    },
    // Getting There Page
    gettingThere: {
      title: "Come Arrivare",
      subtitle: "Informazioni di viaggio per il Lago di Como",
      introText1:
        "Il Lago di Como è facilmente accessibile da Milano e da altre importanti città europee. Ecco tutto ciò che dovete sapere per raggiungere il nostro matrimonio.",
      introText2:
        "È possibile noleggiare un'auto direttamente in aeroporto. Se la prenotate insieme al volo, di solito è molto più economica.",
      byAir: "In Aereo",
      byTrain: "In Treno",
      malpensaTitle: "Aeroporto di Milano Malpensa (MXP)",
      malpensaText:
        "L'aeroporto internazionale più vicino, a circa 1 ora di auto dal Lago di Como. Voli diretti disponibili dalla maggior parte delle principali città del mondo.",
      linateTitle: "Aeroporto di Milano Linate (LIN)",
      linateText:
        "Più vicino al centro di Milano, a circa 1 ora di auto dal Lago di Como. Buona opzione per i voli europei.",
      bergamoTitle: "Aeroporto di Milano Bergamo (BGY)",
      bergamoText:
        "Popolare tra le compagnie aeree low-cost, a circa 1 ora di auto dal Lago di Como. Spesso offre tariffe competitive dalle città europee.",
      fromMalpensaTitle: "Dall'aeroporto di Milano Malpensa",
      fromMalpensaText:
        "Prendete il treno da Malpensa a Milano Centrale, poi proseguite per Como. Il viaggio complessivo dura circa 1 ora. In alternativa, prendete il treno per Mendrisio in Svizzera e cambiate per Como Lago.",
      fromLinateTitle: "Dall'aeroporto di Milano Linate",
      fromLinateText:
        "Prendete la metro da Linate a San Babila (linea blu), cambiate con la linea rossa per raggiungere la stazione di Milano Cadorna (circa 15 minuti). Da Cadorna, prendete il treno per Como Lago (circa 1 ora).",
      fromBergamoTitle: "Dall'aeroporto di Milano Bergamo",
      fromBergamoText:
        "Prendete l'autobus dell'aeroporto per la stazione di Milano Centrale (circa 1 ora). Da Milano Centrale, prendete il treno per Como (circa 1 ora).",
      directToComoTitle: "Direttamente a Como",
      directToComoText:
        "Como ha due stazioni ferroviarie principali: Como San Giovanni (per i treni da Milano Centrale) e Como Lago (per i treni da Milano Cadorna). Como Lago è più vicina al lungolago.",
      lastTrainsTitle: "Ultimi treni per Como",
      lastTrainsText:
        "Vi preghiamo di tenere presente gli orari degli ultimi treni quando pianificate il vostro arrivo: l'ultimo treno da Milano Centrale a Como San Giovanni parte intorno alle 22:43, e l'ultimo treno da Milano Cadorna a Como Lago parte intorno alle 23:16. Consigliamo di prenotare voli che atterrano almeno 3 ore prima dell'ultimo treno per avere tempo sufficiente per il ritiro bagagli, i controlli doganali (se applicabili), il viaggio alla stazione ferroviaria e possibili ritardi del volo.",
      arrivingAtVenueTitle: "Arrivare alla location",
      arrivingAtVenueText:
        "Villa Revel Parravicini è facilmente raggiungibile a piedi da qualsiasi punto del centro di Como, dal molo e dalle stazioni ferroviarie e degli autobus. Vi consigliamo vivamente di soggiornare nel centro di Como la notte del matrimonio, poiché i servizi di autobus, battelli e treni saranno terminati quando il matrimonio finirà a mezzanotte.",
    },
    // Location Page
    location: {
      title: "Lago di Como",
      subtitle: "Esplora la Zona",
      introText:
        "Il Lago di Como è una delle destinazioni più incantevoli d'Italia, immersa ai piedi delle Alpi. Conosciuto per i suoi paesaggi spettacolari, le ville eleganti e aristocratiche e gli affascinanti borghi lacustri, è stato un rifugio per artisti, scrittori e celebrità per secoli. Sia che voi esploriate le strade acciottolate di Como, prendiate un battello per pittoreschi villaggi, o semplicemente gustiate un aperitivo sul lungolago, il Lago di Como offre esperienze indimenticabili a ogni angolo.",
      exploringComoTitle: "Esplorare la Città di Como",
      comoPara1:
        "Como è una graziosa cittadina immersa ai piedi delle Alpi, con lo splendido sfondo del Lago di Como che crea un ambiente pittoresco. Il centro storico è un delizioso labirinto di strette strade acciottolate, fiancheggiate da eleganti negozi di abbigliamento, invitanti caffè, vivaci bar e ristoranti autentici.",
      comoPara2:
        "Fate una piacevole escursione lungo il lungolago, dove potrete godere di viste spettacolari fino all'incantevole villaggio di Cernobbio — una passeggiata facile e panoramica. Visitate il magnifico Duomo di Como, la cattedrale storica della città che fonde magnificamente l'architettura gotica e rinascimentale.",
      comoPara3:
        "Per viste panoramiche mozzafiato, prendete la funicolare fino a Brunate, un villaggio collinare che offre viste stupende del lago e delle montagne circostanti. Gli appassionati d'arte e storia possono esplorare le bellissime ville di Como, come la neoclassica Villa Olmo con i suoi giardini sul lago e le mostre d'arte a rotazione.",
      restaurantsTitle: "Ristoranti e Bar Consigliati",
      restaurants: [
        {
          name: "Bar Krudo",
          type: "Bar e Caffè Italiano",
          description:
            "Situato sulla bellissima Piazza Alessandro Volta, questo bar e caffè italiano è perfetto per drink e pasti informali con vista sul lago.",
        },
        {
          name: "Il Pinzimonio",
          type: "Ristorante, Pizzeria, Cotoletteria",
          description:
            "Situato nel cuore del centro di Como, Il Pinzimonio è un punto di riferimento per molti abitanti locali. Il suo menù, costantemente aggiornato, propone un'ampia gamma di piatti della tradizione italiana, con la cotoletta di pollo e di vitello e la pizza in stile napoletano tra le sue specialità.",
          website: "https://il-pinzimonio.com/",
        },
        {
          name: "Osteria del Gallo",
          type: "Osteria Tradizionale",
          description:
            "Una delle ultime vere osterie di Como, gestita da 41 anni da Giuseppe De Toma e famiglia. Atmosfera autentica in stile tradizionale con menu giornaliero che cambia in base agli ingredienti di stagione. Le specialità includono ravioli freschi, pizzoccheri, carni brasate con polenta, pesce di lago e dolci fatti in casa. Ampia selezione di vini.",
        },
        {
          name: "Pronobis",
          type: "Enoteca e Ristorante",
          description:
            "Un'enoteca e ristorante specializzato in vini di piccoli produttori italiani, con opzioni naturali, biologiche e biodinamiche. Cucina aperta tutti i giorni a pranzo e il sabato sera con menu stagionale. Offre anche formaggi artigianali, salumi e prodotti locali.",
        },
        {
          name: "Ristorante Osteria dal Pain",
          type: "Cucina Locale Tradizionale",
          description:
            "Una vera istituzione nella tradizione dei ristoranti locali di Como con il Lago di Como come sfondo. Offre autentica cucina regionale che combina ingredienti locali con l'eccellenza culinaria italiana tradizionale.",
        },
        {
          name: "Caffè Maya",
          type: "Caffetteria e Torrefazione",
          description:
            "Torrefazione artigianale con più sedi a Como. Perfetto per un drink veloce al bar o per gustare la loro famosa cioccolata calda italiana. Conosciuto per il caffè di qualità e l'atmosfera accogliente.",
        },
      ],
      recommendedPlatesTitle: "Piatti Consigliati",
      platesPara1:
        "La cucina di Como riflette la sua posizione ai piedi delle Alpi, fondendo le tradizioni montane e alpine con i sapori del nord Italia.",
      platesPara2:
        "La regione è conosciuta per piatti sostanziosi e rustici che mettono in mostra ingredienti locali come polenta, pesce di lago e carni ricche. Ecco alcuni piatti tradizionali da provare assolutamente durante la vostra visita:",
      plates: [
        {
          name: "Pizzoccheri",
          description:
            "Un sostanzioso piatto di pasta di grano saraceno dalla vicina Valtellina, stratificato con patate, verza, aglio e generose quantità di formaggio locale (solitamente Casera e Bitto), rifinito con burro e salvia. Perfetto per le serate di montagna più fresche.",
        },
        {
          name: "Ossobuco",
          description:
            "Stinchi di vitello brasati cotti lentamente in vino bianco, brodo e verdure fino a quando la carne si stacca dall'osso. Tradizionalmente servito con risotto alla milanese o polenta, e guarnito con gremolata (scorza di limone, aglio e prezzemolo).",
        },
        {
          name: "Risotto alla Milanese",
          description:
            "L'iconico risotto dorato della vicina Milano, colorato e aromatizzato con zafferano. Cremoso e lussuoso, fatto con burro, Parmigiano-Reggiano e midollo osseo. Spesso servito insieme all'ossobuco ma delizioso anche da solo.",
        },
        {
          name: "Cotoletta alla Milanese",
          description:
            "Una cotoletta di vitello impanata, battuta sottile e fritta nel burro fino a diventare dorata e croccante. Simile alla Wiener schnitzel ma con il proprio carattere milanese. Semplice, classica e assolutamente soddisfacente.",
        },
        {
          name: "Polenta",
          description:
            "Un pilastro della cucina montana del nord Italia, questa polenta di farina di mais viene servita morbida e cremosa o raffreddata e grigliata. Spesso accompagnata da carni brasate, funghi o formaggi locali. Cercate la polenta taragna, fatta con farina di grano saraceno per un sapore extra.",
        },
        {
          name: "Tagliatelle con Porcini",
          description:
            "Pasta fresca a nastro condita con funghi porcini, un ingrediente pregiato delle foreste alpine. I funghi terrosi e aromatici sono tipicamente saltati con aglio, prezzemolo e un tocco di panna o burro. Una celebrazione delle tradizioni di raccolta della regione e del raccolto autunnale.",
        },
      ],
      exploringLakeTitle: "Esplorare il Lago di Como",
      lakePara1:
        "Il Lago di Como è punteggiato di villaggi pittoreschi, tutti facilmente accessibili in barca dal terminal dei traghetti nella città di Como. Ogni villaggio offre il proprio fascino e carattere unici, rendendo il giro in barca un modo delizioso per esplorare la regione.",
      lakePara2:
        'Bellagio, la principale attrazione turistica, è conosciuta come la "Perla del Lago di Como" e si trova nel punto in cui il lago si divide in due rami. Questo bellissimo villaggio incanta i visitatori con le sue strade acciottolate tortuose, edifici colorati, giardini eleganti e viste mozzafiato sul lago.',
      lakePara3:
        "Più vicino a Como, troverete l'incantevole Torno, un villaggio molto grazioso perfetto per una visita tranquilla, e Cernobbio con il suo bel lungolago. Più su nel lago, Bellano presenta una grande cascata spettacolare, mentre Varenna affascina con il suo bellissimo lungolago fiancheggiato da case color pastello.",
      lakePara4:
        "Per un'esperienza culturale unica, visitate la storica Abbazia Cistercense di Santa Maria di Piona, un monastero cistercense in alto sul lago risalente al 1138. Questo santuario pacifico offre uno sguardo su secoli di vita monastica e viste stupende del paesaggio circostante.",
      localTransportTitle: "Trasporti Locali",
      transportIntro:
        "Una volta al Lago di Como, barche, autobus e taxi sono i principali mezzi di trasporto tra le città. La villa è facilmente accessibile a piedi da qualsiasi punto della città di Como e dal molo, se soggiornate in un altro villaggio e prendete una barca.",
      boatsTitle: "Barche",
      boatsPara1:
        "Le barche sono economiche e convenienti. Ogni città ha un molo e le barche sono relativamente frequenti. C'è una barca veloce (aliscafo) che è comoda se si viaggia più in alto sul lago (oltre Bellagio), ma si esaurisce velocemente e non è possibile prenotare i biglietti della barca online.",
      boatsPara2:
        "Se avete intenzione di viaggiare più in alto sul lago, dovreste alzarvi presto il giorno stesso e andare al molo per prenotare la barca veloce.",
      boatsPara3: "Il servizio di barche termina tipicamente alle 22:00.",
      busesTitle: "Autobus",
      busesPara1:
        "Gli autobus sono anche un modo economico e conveniente per viaggiare intorno al lago. Non sono frequenti come le barche ma sono una buona opzione se volete evitare la folla al molo.",
      busesPara2:
        "È possibile pagare il biglietto direttamente sull'autobus utilizzando una carta di debito o di credito.",
      busesPara3: "Il servizio di autobus termina tipicamente alle 00:00.",
      taxisTitle: "Taxi",
      taxisPara1:
        "I taxi sono facilmente disponibili ma molto costosi. Un viaggio di quindici minuti può costare €60.",
      taxisPara2:
        "Uber e altri servizi simili ai taxi non sono facilmente disponibili o affidabili a Como.",
    },
    // RSVP Page
    rsvp: {
      title: "RSVP",
      subtitle: "Unitevi a noi per il nostro giorno speciale",
      intro:
        "Saremmo onorati di festeggiare insieme a voi! Vi preghiamo di farci sapere se potrete partecipare.",
      yourName: "Il tuo nome",
      yourNameTooltip: "Per favore inserisci il tuo nome completo",
      yourNamePlaceholder: "es., Mario Rossi",
      willYouAttend: "Parteciperai?",
      pleaseEnterNameFirst: "Per favore inserisci prima il tuo nome",
      yesAttending: "Sì, ci sarò! 🎉",
      noAttending: "Mi dispiace, non posso venire",
      otherGuestsAttending: "Altri ospiti nel tuo RSVP che partecipano",
      otherGuestsAttendingTooltip:
        "Per favore inserisci il nome completo di ogni ospite del tuo gruppo",
      guestFullName: "Ospite",
      fullName: "Nome Completo",
      addGuestAttending: "+ Aggiungi Ospite che Partecipa",
      otherGuestsNotAttending: "Altri ospiti nel tuo RSVP che non partecipano",
      otherGuestsNotAttendingTooltip:
        "Se conosci ospiti che non possono partecipare, elenca i loro nomi qui",
      addGuestNotAttending: "+ Aggiungi Ospite che Non Partecipa",
      attendingBabies: "Neonati che partecipano (sotto i 18 mesi)",
      attendingBabiesTooltip:
        "Seleziona quali ospiti sono neonati sotto i 18 mesi",
      selectBaby: "Seleziona neonato",
      addBaby: "+ Aggiungi Neonato",
      attendingChildren: "Bambini che partecipano (sotto i 10 anni)",
      attendingChildrenTooltip:
        "Seleziona quali ospiti sono bambini tra i 18 mesi e i 10 anni",
      selectChild: "Seleziona bambino",
      addChild: "+ Aggiungi Bambino",
      dietaryRequirements: "Esigenze dietetiche",
      dietaryRequirementsTooltip:
        "Seleziona le esigenze dietetiche per i tuoi ospiti (Vegano, Vegetariano)",
      none: "Nessuna",
      vegan: "Vegano",
      vegetarian: "Vegetariano",
      selectGuest: "Seleziona Ospite",
      addDietaryRequirement: "+ Aggiungi esigenza dietetica",
      foodAllergies: "Allergie alimentari",
      foodAllergiesTooltip:
        "Elenca eventuali allergie alimentari per i tuoi ospiti per garantire la sicurezza di tutti",
      foodAllergiesPlaceholder: "es., Arachidi, Crostacei, Latticini",
      addFoodAllergy: "+ Aggiungi allergia alimentare",
      messageToCouple: "Messaggio agli sposi",
      messageToCoupleTooltip:
        "Condividi il tuo entusiasmo, i tuoi auguri o eventuali domande!",
      messagePlaceholder: "Non vediamo l'ora di festeggiare con voi! 💕",
      submitRSVP: "Invia RSVP",
      validationError:
        "Per favore compila correttamente tutti i campi obbligatori.",
      successMessage: "Grazie per il tuo RSVP! Ci vediamo lì! 💒",
      successMessageAttending: "Non vediamo l'ora di vedervi! 🎉",
      successMessageNotAttending:
        "Ci dispiace non vedervi e ci sentiremo presto! 💕",
      // Personalized card messages
      dearGuest: "Caro/a",
      thankYouAttending:
        "Grazie mille per aver confermato la tua partecipazione al nostro matrimonio. Siamo assolutamente felici che ti unirai a noi nel nostro giorno speciale.",
      thankYouNotAttending:
        "Grazie per avercelo fatto sapere. Anche se siamo tristi che non potrai unirti a noi nel nostro giorno speciale, capiamo perfettamente e speriamo di festeggiare con te presto.",
      thankYouMixed:
        "Grazie per la tua risposta. Siamo felici che alcuni del tuo gruppo si uniranno a noi, e capiamo che non tutti possono partecipare. Non vediamo l'ora di festeggiare con coloro che potranno essere presenti.",
      lookForwardTo: "Non vediamo l'ora di festeggiare con te al Lago di Como.",
      withLove: "Con amore e trepidazione,",
      coupleNames: "Cinzia & Joseph",
      errorMessage:
        "Si è verificato un errore nell'invio del tuo RSVP. Per favore riprova.",
      joeAlertTitle: "Non Così in Fretta, Joe Schuldt!",
      joeAlertMessage: "Puoi solo partecipare a questo matrimonio.",
      joeAlertInsult: "Testa di cazzo.",
      joeAlertButton: "OK, Invia Accettazione! 🎉",
    },
    // Footer
    footer: {
      location: "Lago di Como, Italia",
      year: "2026",
      message: "Con amore e trepidazione",
    },
  },
};
